const noop = () => {};
let googleIdentityServicesInstance;

// eslint-disable-next-line camelcase
const initGoogleSdk = (client_id, errorCallback) => {
    if (typeof window.google === 'undefined') {
        try {
            const params = {
                client_id,
                scope: 'profile email',
                callback: '',
            };
            Odigeo.require(['https://accounts.google.com/gsi/client'], function() {
                googleIdentityServicesInstance = window?.google?.accounts?.oauth2?.initTokenClient?.(params);
            });
        } catch (error) {
            errorCallback(error);
        }
    }
};

const GoogleSdkManager = {
    init(appId, errorCallback = noop) {
        initGoogleSdk(appId, errorCallback);
    },
    login(callback, errorCallback = noop) {
        try {
            if (typeof googleIdentityServicesInstance.callback !== 'function') {
                googleIdentityServicesInstance.callback = callback;
            }
            googleIdentityServicesInstance.requestAccessToken();
        } catch (error) {
            errorCallback(error);
        }
    },
};

module.exports = {
    GoogleSdkManager,
};
